window.initSearchPlaceMap = function () {
  'use strict';
  var $form = $('form[data-report-post-form]');
  var $mapElements = $form.find('.google-place-api');
  var companyAddress = $form.data('company-address');
  var defaultZoom = 15;
  var geocoder = new google.maps.Geocoder;

  $.each($mapElements, function () {

    var itemId = $(this).data('item-id');
    var placeId = $(this).find('input[type=hidden]').val();
    var marker, defaultMarker;

    var $input = $(this).find('.pac-input[data-item-id=' + itemId + ']');
    var input = $(this).find('.pac-input[data-item-id=' + itemId + ']')[0];
    var map = new google.maps.Map($(this).find('.search-place-map')[0]);
    
    //初期値のplace_idのマーカー表示
    if (placeId) {
      var geocoder = new google.maps.Geocoder;
      geocoder.geocode({'placeId': placeId}, function (results, status) {
        if (status === 'OK') {
          if (results[0]) {
            map.setZoom(11);
            map.setZoom(defaultZoom);
            map.setCenter(results[0].geometry.location);
            defaultMarker = new google.maps.Marker({
              map: map,
              position: results[0].geometry.location
            });
          } else {
            toastr.error('地図の読み込みに失敗しました。お手数ですがページを更新してください。')
          }
        } else {
          toastr.error('地図の読み込みに失敗しました。お手数ですがページを更新してください。')
        }
      });
    } else {
      // デフォルトの座標をセット
      geocodeAddress(map);
    }

    // グーグルマップの入力補完を利用して入力を終えた場合は、該当itemにhiddenのplace_idをセットし、マップを該当位置にセットする。 place_idとplace_nameのパラメータが送信される。
    // グーグルマップの入力補完を利用せずに入力を終えた場合は、該当itemのhiddenのplace_idが存在すれば削除し、マップをリセットする。place_nameパラメータのみ送信される。
    // 英数キーの入力を検知
    $input.keypress(function () {
      $(':hidden[name="report_item[restaurant][' + itemId + '][place_id]"]').remove();
      geocodeAddress(map);
      if (marker) {
        marker.setMap(null);
      }
      if (defaultMarker) {
        defaultMarker.setMap(null);
      }
    });

    // deleteキーとbackspaceキーの入力を検知
    $input.keyup(function (e) {
        if (e.keyCode == 46 || e.keyCode == 8) {
          $(':hidden[name="report_item[restaurant][' + itemId + '][place_id]"]').remove();
          geocodeAddress(map);
          if (marker) {
            marker.setMap(null);
          }
          if (defaultMarker) {
            defaultMarker.setMap(null);
          }
        }
      });

    var autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.bindTo('bounds', map);
    autocomplete.itemId = itemId;

    marker = new google.maps.Marker({
      map: map
    });

    autocomplete.addListener('place_changed', function () {
      //マーカーの削除
      if (marker) {
        marker.setMap(null);
      }
      if (defaultMarker) {
        defaultMarker.setMap(null);
      }

      marker = new google.maps.Marker({
        map: map
      });

      var place = autocomplete.getPlace();
      if (!place.geometry) {
        return;
      }
      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(defaultZoom);
      }

      input.value = place.name;

      // Set the position of the marker using the place ID and location.
      marker.setPlace({
        placeId: place.place_id,
        location: place.geometry.location
      });
      marker.setVisible(true);
      $(':hidden[name="report_item[restaurant][' + this.itemId + '][place_id]"]').remove();
      $('<input>').attr('type', 'hidden').attr('name', 'report_item[restaurant][' + this.itemId + '][place_id]').attr('value', place.place_id).appendTo($form);
    });
  });

  //住所からマップの座標を指定する
  function geocodeAddress(map) {
    geocoder.geocode(
      {
        'address': companyAddress,
        'region': 'jp'
      }
      , function (results, status) {
        if (status === 'OK') {
          if (results[0]) {
            map.setZoom(defaultZoom);
            map.setCenter(results[0].geometry.location);
          } else {
            toastr.error('地図の読み込みに失敗しました。お手数ですがページを更新してください。')
          }
        } else {
          toastr.error('地図の読み込みに失敗しました。お手数ですがページを更新してください。')
        }
      });
  }
}

